










































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { IOrderData } from '@/api/types'
import { IVendor } from '@/api/types-vendor'
import VendorSelect from './VendorSelect.vue'
import { createIndependentVendor } from '@/api/vendors'
import VendorData from '@/views/vendors/components/VendorData.vue'
import { assignVendor } from '@/api/orders'

export enum DataSourceType {
  Order,
  Contact,
  None
}

@Component({
  name: 'VendorCreate',
  components: {
    VendorSelect,
    VendorData
  }
})
export default class extends Vue {
  @Prop({ type: Object }) value!: IOrderData
  @Prop({ type: Boolean, default: false, required: false }) disableAssignVendorCTA: boolean

  private newVendor = 0
  private loading = false
  private lodingCreateAndAssign = false
  private dataSourceType: DataSourceType | Number = -1
  private dataSource: any = this.value
  private dialogConfirmVendorFee = false

  data() {
    return {
      states: {
        AL: 'Alabama',
        AK: 'Alaska',
        AS: 'American Samoa',
        AZ: 'Arizona',
        AR: 'Arkansas',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DE: 'Delaware',
        DC: 'District Of Columbia',
        FM: 'Federated States Of Micronesia',
        FL: 'Florida',
        GA: 'Georgia',
        GU: 'Guam',
        HI: 'Hawaii',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        IA: 'Iowa',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        ME: 'Maine',
        MH: 'Marshall Islands',
        MD: 'Maryland',
        MA: 'Massachusetts',
        MI: 'Michigan',
        MN: 'Minnesota',
        MS: 'Mississippi',
        MO: 'Missouri',
        MT: 'Montana',
        NE: 'Nebraska',
        NV: 'Nevada',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NY: 'New York',
        NC: 'North Carolina',
        ND: 'North Dakota',
        MP: 'Northern Mariana Islands',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PW: 'Palau',
        PA: 'Pennsylvania',
        PR: 'Puerto Rico',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VT: 'Vermont',
        VI: 'Virgin Islands',
        VA: 'Virginia',
        WA: 'Washington',
        WV: 'West Virginia',
        WI: 'Wisconsin',
        WY: 'Wyoming'
      },
      zipError: false,
      zipErrorMessage: ''
    }
  }

  @Watch('newVendor')
  onChildChanged(val: boolean) {
    if (!val) {
      this.dataSourceType = -1
    } else {
      this.dataSourceType = DataSourceType.Contact
    }
  }

  private vendor: IVendor = {
    vendorId: 0,
    firstName: '',
    lastName: '',
    email: '',
    paymentMethod: '',
    phone: '',
    phone2: '',
    address: '',
    city: '',
    state: '',
    postalCode: '',
    latitude: 0,
    longitude: 0,
    vendorCompanyId: 0,
    vendorTypeId: 0,
    accountingId: '',
    vendorStatusId: 0,
    vendorRoleId: 0,
    vendorRank: 0,
    vendorPhoto: '',
    haltAssignStart: '',
    haltAssignStop: '',
    dailyOrderLimit: 0,
    verified: false,
    verificationNote: '',
    performance: 0,
    ordersAssigned: 0,
    ordersInProcess: 0,
    ordersLate: 0,
    ordersOnHold: 0,
    ordersCompleted: 0,
    ordersDeclined: 0,
    notifyMode: '',
    notifyOnSubmit: false,
    notifyOnLostBid: false,
    notifyOnReAssign: false,
    deleted: false
  }

  private closeModal() {
    this.dialogConfirmVendorFee = false
  }

  private updateVendor(vendorId: number) {
    this.$emit('update-vendor', vendorId)
  }

  private updateNewVendor(vendorId: number) {
    this.$emit('update-new-vendor', vendorId)
  }

  private assignVendor() {
    let vendor: IVendor | null = null

    console.log(this.dataSourceType)
    console.log(DataSourceType.Order)

    switch (this.dataSourceType) {
      // Borrowr/Order
      case DataSourceType.Order:
        vendor = {
          firstName: this.vendor.firstName,
          lastName: this.vendor.lastName,
          email: this.vendor.email,
          paymentMethod: '',
          phone: this.vendor.phone,
          phone2: this.vendor.phone2,
          address: this.value.subjectAddress,
          city: this.value.subjectCity,
          state: this.value.subjectState,
          postalCode: this.value.subjectPostalCode
        }
        break
      // Contact
      case DataSourceType.Contact:
        vendor = {
          firstName: this.value.contactFirstName,
          lastName: this.value.contactLastName,
          email: this.value.contactEmail,
          paymentMethod: '',
          phone: this.value.contactPhone,
          phone2: this.value.contactPhone2,
          address: this.vendor.address,
          city: this.vendor.city,
          state: this.vendor.state,
          postalCode: this.vendor.postalCode
        }
        break
      // None
      case DataSourceType.None:
        vendor = this.vendor
        break
      default:
        vendor = null
        break
    }

    if (vendor) {
      vendor.vendorCompanyId = 0
      vendor.vendorRoleId = 0
      vendor.latitude = this.value.latitude
      vendor.longitude = this.value.longitude
      vendor.haltAssignStart = null
      vendor.haltAssignStop = null
    }

    return vendor
  }

  private async createVendor() {
    this.loading = true

    // Add New Vendor
    const vendor = this.assignVendor()

    const request = createIndependentVendor(vendor)
    request.then(() => {
      this.$notify({
        title: 'Success',
        message: 'Vendor added succesfully',
        type: 'success',
        duration: 5000
      })
      this.newVendor = -1
    }).catch((error: any) => {
      this.$notify({
        title: 'Error',
        message: `Vendor error: ${error}`,
        type: 'error',
        duration: 6000
      })
    }).finally(() => {
      this.loading = false
    })
  }

  private createAndAssignVendor() {
    this.lodingCreateAndAssign = true

    // Add New Vendor
    const vendor = this.assignVendor()
    console.log(`after assignVendor order.vendorId=${this.value.vendorId} vendor.vendorId=${vendor.vendorId}.`)

    if (this.value.vendorFee < 0) {
      this.$notify({
        title: 'Error',
        message: 'Vendor Fee can\'t be a negative number',
        type: 'error',
        duration: 5000
      })
      this.lodingCreateAndAssign = false
      return false
    }

    const request = createIndependentVendor(vendor)
    request.then((response) => {
      // Assign It to the order
      this.handleAssignVendor(response.data.vendorId, this.value.orderId, this.value.vendorFee)
    }).catch((error: any) => {
      this.lodingCreateAndAssign = false
      this.$notify({
        title: 'Error',
        message: `Vendor error: ${error}`,
        type: 'error',
        duration: 6000
      })
    })
  }

  private async handleAssignVendor(vendorId: number, orderId: number, vendorFee: number) {
    assignVendor({ orderId: orderId, vendorId: vendorId, vendorFee: vendorFee }).then((response) => {
      this.$notify({
        title: 'Success',
        message: `Vendor Assigned to ${orderId} successfully.`,
        type: 'success',
        duration: 6000
      })
      // Change to Slected section
      this.newVendor = 0
      this.lodingCreateAndAssign = false
      this.dialogConfirmVendorFee = false
      this.$emit('updateData', response.data)
    }, (error) => {
    // Server Error!? is displayed in request.ts
      console.log(`Server-side error! ${error}`)
    })
    return false
  }
}
